import styled from "styled-components";

//LinkR as LinkRouter
import { Link as LinkR } from "react-router-dom";

//LinkS kao LinkScroll
import { Link as LinkS } from "react-scroll";

export const Nav = styled.nav`
	background: ${({ scrollNav }) => (scrollNav ? "#BDAA8C" : "transparent")};
	height: 80px;
	margin-top: -80px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 1rem;
	position: sticky;
	top: 0;
	z-index: 10;

	@media screen and (max-width: 960px) {
		transition: 0.8s all ease;
	}
`;

export const NavbarContainer = styled.div`
	height: 80px;
	display: flex;
	justify-content: space-between;
	width: 100%;
	top: 0;
	z-index: 1;
	padding: 0 24px;
	max-width: 800px;
`;

export const NavLogo = styled(LinkR)`
	color: #fff;
	justify-self: flex-start;
	cursor: pointer;
	font-size: 1.5rem;
	display: flex;
	align-items: center;
	margin-left: 24px;
	font-weight: bold;
	text-decoration: none;
`;

export const MobileIcon = styled.div`
	display: none;

	@media screen and (max-width: 768px) {
		display: block;
		position: absolute;
		top: 0;
		right: 0;
		// 100% predlog da pomer FaBar u levo koliko
		transform: translate(-150%, 60%);
		font-size: 1.8rem;
		cursor: pointer;
		color: #fff;
	}
`;

export const NavMenu = styled.ul`
	display: flex;
	align-items: center;
	list-style: none;
	text-align: center;
	margin-right: -22px;

	@media screen and (max-width: 768px) {
		display: none;
	}
`;

export const NavItem = styled.li`
	height: 80px;
`;
export const NavLinks = styled(LinkS)`
	color: #fff;
	display: flex;
	align-items: center;
	text-decoration: none;
	padding: 0 1rem;
	height: 100%;
	cursor: pointer;

	&.active {
		border-bottom: 5px solid #61714d;
	}
`;

export const NavBtn = styled.nav`
	display: flex;
	align-items: center;

	@media screen and (max-width: 768px) {
		display: none;
	}
`;

export const NavBtnLink = styled(LinkR)`
	border-radius: 50px;
	background: #3333ff;
	white-space: nowrap;
	padding: 10px 22px;
	color: #010606;
	outline: none;
	border: none;
	cursor: pointer;
	transition: all 0.2s ease-in-out;
	text-decoration: none;

	&:hover {
		transition: all 0.2 ease-in-out;
		background: #fff;
		color: #010606;
	}
`;

export const NavbarLogo = styled.img`
	height: 60px;
	width: 175px;
	object-fit: contain;

	/* @media screen and (max-width: 1000px) {
		height: 140px;
		width: 160px;
	}
	@media screen and (max-width: 768px) {
		height: 130px;
		width: 200px;
	} */
`;
